module.exports = {"showMore":"Alle anzeigen","showLess":"Weniger anzeigen","more":"und einen mehr | und {amount} mehr"}